import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export class AnchorNav extends AbstractComponent {
  init() {
    const items = this.el.querySelectorAll('[data-anchor]');
    const mainHeight = this.el.getBoundingClientRect().height;

    const setActiveLabel = id => {
      items.forEach(item => {
        item.classList.remove('is-active');
      });

      id && this.el.querySelector(`[data-anchor="${id}"]`)?.classList.add('is-active');
    };

    items.forEach((item, i) => {
      const elementId = item.dataset.anchor;
      const el = document.getElementById(elementId);
      const nextEl = document.getElementById(items[i + 1]?.dataset.anchor);
      const elHeight =
        nextEl && el ? nextEl.getBoundingClientRect().top - el.getBoundingClientRect().top : window.innerHeight;


      item.addEventListener('click', e => {
        e.preventDefault();
        gsap.to(window, {
          duration: 0.3,
          scrollTo: {
            y: `#${elementId}`,
            offsetY: mainHeight - 2,
          },
          onStart: () => {
            document.body.classList.remove('is-scrolled-up');
            document.body.classList.remove('is-scrolled-down');
            document.body.classList.add('is-scrolling');
          },
          onComplete: () => {
            document.body.classList.remove('is-scrolled-up');
            document.body.classList.add('is-scrolled-down');
            document.body.classList.remove('is-scrolling');
          },
        });
      });

      gsap.to(window, {
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top center',
          end: `=+${elHeight} center`,
          toggleActions: 'play none none reverse',
          onEnter: () => setActiveLabel(elementId),
          onEnterBack: () => setActiveLabel(elementId),
          onLeave: () => setActiveLabel(''),
          onLeaveBack: () => setActiveLabel(''),
        },
      });
    });
  }
}

register('anchor-nav', AnchorNav);
